import { authFetch, getAccessToken } from '../utils/auth';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.adjusterphoto.com';

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  token: string;
  new_password: string;
}

export interface ChangePasswordRequest {
  old_password: string;
  new_password: string;
}

/**
 * Request a password reset email
 */
export async function forgotPassword(data: ForgotPasswordRequest): Promise<{ message: string }> {
  const response = await fetch(`${API_URL}/api/forgot-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || 'Failed to request password reset');
  }

  return response.json();
}

/**
 * Reset password using a token
 */
export async function resetPassword(data: ResetPasswordRequest): Promise<{ message: string }> {
  const response = await fetch(`${API_URL}/api/reset-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || 'Failed to reset password');
  }

  return response.json();
}

/**
 * Verify if a reset token is valid
 */
export async function verifyResetToken(token: string): Promise<{ valid: boolean }> {
  const response = await fetch(`${API_URL}/api/verify-reset-token?token=${encodeURIComponent(token)}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || 'Invalid or expired token');
  }

  return response.json();
}

/**
 * Change password for authenticated user
 */
export async function changePassword(data: ChangePasswordRequest): Promise<{ message: string }> {
  if (!getAccessToken()) {
    throw new Error('Not authenticated');
  }

  const response = await authFetch(`${API_URL}/api/change-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || 'Failed to change password');
  }

  return response.json();
}